import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useLanguage } from '../../contexts/LanguageContext';

export const ReturnFromCustomerPage: React.FC = () => {
  const { theme } = useTheme();
  const { t } = useLanguage();

  return (
    <div className={`content-section ${theme.isDark ? 'dark' : 'light'}`}>
      <h2>{t('menu.return-from-customer')}</h2>
      <p>Страница возврата от покупателя в разработке...</p>
    </div>
  );
};
